import {
  FireIcon,
  LiveIcon,
  PTIcon1,
  BoltIcon,
  CalenderIcon1,
} from "../../../images/icons/icons";

export const categoryTypes = [
  { value: "recommended", label: "Recommended", icon: <FireIcon /> },
  { value: "live", label: "Live", icon: <LiveIcon /> },
  { value: "pt", label: "PT", icon: <PTIcon1 /> },
  {
    value: "book_free_trial",
    label: "Book Free Trial",
    icon: <CalenderIcon1 />,
  },
  { value: "none", label: "None", icon: <BoltIcon /> },
];

export const validateAddonCategoryForm = (values) => {
  const errors = {};

  if (!values.name || !values.name.trim()) {
    errors.name = "Category name is required!";
  }

  if (!values.description || !values.description.trim()) {
    errors.description = "Category description is required!";
  }

  if (!values.categoryImage) {
    errors.categoryImage = "Category image is required!";
  }

  return errors;
};
